import * as amplitude from '@amplitude/analytics-browser';

import { ApiResponseType } from '../types/ApiResponseTypes';
import { encryptPasswordAsync } from './cryptoHelper';
import trackEvent from './trackEvent';

const apiUrl = process.env.NEXT_PUBLIC_API_URL;

const request = async (
  action: 'login' | 'logout',
  email?: string,
  password?: string,
  session?: string
): Promise<ApiResponseType> => {
  // Encrypt password if provided
  const encryptedPassword = password
    ? await encryptPasswordAsync(password)
    : null;

  const response = await fetch(`${apiUrl}/${action}`, {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      email,
      password: encryptedPassword,
      session,
    }),
  });

  const responseJson = await response.json();
  return responseJson;
};

const login = async (
  email?: string,
  password?: string,
  session?: string // admin or broker logegd in user should send their session to change to other user or return to them self
): Promise<ApiResponseType> => {
  const response = await request('login', email, password, session);

  return response;
};

const logout = async (): Promise<ApiResponseType> => {
  const response = await request('logout');
  trackEvent('Logout');
  amplitude.setUserId('');

  return response;
};

export { login, logout };
